import type { Stage } from '@/domain/creature/types';

const FAST =
  typeof import.meta !== 'undefined' &&
  (import.meta.env?.VITE_FAST_LIFECYCLE === '1' ||
    import.meta.env?.VITE_FAST_LIFECYCLE === 'true');

/** Durações dos estágios. */
export const FAST_STAGE_DURATIONS = {
  egg: 60_000,
  baby: 5 * 60_000,
  teen: 10 * 60_000,
  adult: 30 * 60_000,
  elder: 5 * 60_000,
} as const;

export const PROD_STAGE_DURATIONS = {
  egg: 60 * 60_000,
  baby: 8 * 60 * 60_000,
  teen: 24 * 60 * 60_000,
  adult: 7 * 24 * 60 * 60_000,
  elder: 7 * 24 * 60 * 60_000,
} as const;

export const STAGE_DURATIONS = FAST ? FAST_STAGE_DURATIONS : PROD_STAGE_DURATIONS;

/** Multiplicador de decay por estágio. */
export const STAGE_DECAY_MULTIPLIER: Record<Stage, number> = {
  egg: 0,
  baby: 0.5,
  teen: 0.8,
  adult: 1.0,
  elder: 1.3,
  dead: 0,
};

export const FAST_HUNGER_DECAY_MS = 30_000;
export const PROD_HUNGER_DECAY_MS = 600_000;
export const HUNGER_DECAY_MS = FAST ? FAST_HUNGER_DECAY_MS : PROD_HUNGER_DECAY_MS;

export const FAST_HAPPINESS_DECAY_MS = 45_000;
export const PROD_HAPPINESS_DECAY_MS = 900_000;
export const HAPPINESS_DECAY_MS = FAST ? FAST_HAPPINESS_DECAY_MS : PROD_HAPPINESS_DECAY_MS;

export const FAST_POOP_INTERVAL_MS = 60_000;
export const PROD_POOP_INTERVAL_MS = 30 * 60_000;
export const POOP_INTERVAL_MS = FAST ? FAST_POOP_INTERVAL_MS : PROD_POOP_INTERVAL_MS;

export const FAST_DISCIPLINE_DECAY_MS = 60_000;
export const PROD_DISCIPLINE_DECAY_MS = 30 * 60_000;
export const DISCIPLINE_DECAY_MS = FAST ? FAST_DISCIPLINE_DECAY_MS : PROD_DISCIPLINE_DECAY_MS;

export const FEED_AMOUNT = 20;
export const PLAY_AMOUNT = 25;
export const DISCIPLINE_BUMP = 15;

export const ATTENTION_THRESHOLD = 30;

/** Tempo ininterrupto de hunger/happiness baixo + discipline baixo para iniciar tantrum. */
export const FAST_TANTRUM_TRIGGER_MS = 30_000;
export const PROD_TANTRUM_TRIGGER_MS = 60_000;
export const TANTRUM_TRIGGER_MS = FAST ? FAST_TANTRUM_TRIGGER_MS : PROD_TANTRUM_TRIGGER_MS;
export const TANTRUM_DECAY_BOOST = 1.2;

export const SICK_HEALTH_THRESHOLD = 20;
export const FAST_SICK_HEALTH_DURATION_MS = 60_000;
export const PROD_SICK_HEALTH_DURATION_MS = 5 * 60_000;
export const SICK_HEALTH_DURATION_MS = FAST ? FAST_SICK_HEALTH_DURATION_MS : PROD_SICK_HEALTH_DURATION_MS;
export const SICK_POOP_THRESHOLD = 3;
export const FAST_SICK_DEATH_MS = 5 * 60_000;
export const PROD_SICK_DEATH_MS = 2 * 60 * 60_000;
export const SICK_DEATH_MS = FAST ? FAST_SICK_DEATH_MS : PROD_SICK_DEATH_MS;

export const FAST_HEAL_COOLDOWN_MS = 60_000;
export const PROD_HEAL_COOLDOWN_MS = 30 * 60_000;
export const HEAL_COOLDOWN_MS = FAST ? FAST_HEAL_COOLDOWN_MS : PROD_HEAL_COOLDOWN_MS;
export const HEAL_DOSES_REQUIRED = 2;

/** NPCs aposentados envelhecem mais devagar que o bichinho ativo, pra dar
 * janela maior de cruzamento com a família ao longo das gerações. */
export const NPC_TIME_SCALE = 0.25;

export const FEED_COOLDOWN_MS = 5_000;
export const PLAY_COOLDOWN_MS = 3_000;

export const ELDER_HEALTH_PENALTY = 10;

/** Cap absoluto do offline catch-up. */
export const CATCHUP_MAX_MS = FAST ? 60 * 60_000 : 14 * 24 * 60 * 60_000;

/** Tamanho máximo de cada chunk em runCareTick (segurança contra dt grande). */
export const TICK_MAX_CHUNK_MS = 60 * 60_000;
